import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "lib/api";

const CAMP_ACCESOS_PREFIX = ["dashboard", "camp", "accesos"];
const JSON_HEADERS = { "Content-Type": "application/json" };

const campAccesosKeys = {
  list() {
    return ["dashboard", "camp", "accesos"];
  },
  instructoresSearch(q) {
    return ["dashboard", "camp", "accesos", "instructores", { q }];
  },
};

function invalidateCampAccesos(qc) {
  qc.invalidateQueries({ queryKey: CAMP_ACCESOS_PREFIX });
}

export function useDashboardCampAccesos(enabled = true) {
  return useQuery({
    queryKey: campAccesosKeys.list(),
    queryFn: () => api("/dashboard/camp/accesos"),
    enabled,
    staleTime: 20_000,
  });
}

export function useSearchDashboardCampInstructores(q, enabled = true) {
  const query = String(q || "").trim();
  return useQuery({
    queryKey: campAccesosKeys.instructoresSearch(query),
    queryFn: () => api(`/dashboard/camp/accesos/instructores?q=${encodeURIComponent(query)}`),
    enabled: enabled && query.length >= 2,
    staleTime: 10_000,
  });
}

export function useSetDashboardCampAccesoForUsuario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ usuarioId, payload }) =>
      api(`/dashboard/camp/accesos/usuarios/${usuarioId}`, {
        method: "PUT",
        body: JSON.stringify(payload),
        headers: JSON_HEADERS,
      }),
    onSuccess: () => invalidateCampAccesos(qc),
  });
}

export function useClearDashboardCampAccesoForUsuario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (usuarioId) => api(`/dashboard/camp/accesos/usuarios/${usuarioId}`, { method: "DELETE" }),
    onSuccess: () => invalidateCampAccesos(qc),
  });
}
